<!-- Modal backdrop -->
<div class="modal-backdrop" [class.show]="showModal" (click)="closeModal()"></div>

<!-- Password Success Modal -->
<div class="custom-modal" [class.show]="showModal" (click)="closeModal()">
  <div class="modal-dialog" (click)="stopPropagation($event)">
    <div class="modal-content">
      <div class="modal-body">
        <div class="success-view">
          <div class="success-icon-container">
            <div class="success-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
              </svg>
            </div>
          </div>
          <h5 class="modal-title-custom">Successful!</h5>
          <p class="modal-text">Change Password Successful!</p>

          <div class="modal-footer-custom">
            <button type="button" class="btn btn-success" (click)="closeModal()">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
